import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '@/lib/utils';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root
    ref={ref}
    className={cn('flex flex-wrap gap-3 data-[disabled]:opacity-60', className)}
    {...props}
  />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
    children?: React.ReactNode;
  }
>(({ className, children, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      'group inline-flex items-center gap-2 text-sm text-text-primary outline-none',
      'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60',
      'focus-visible:ring-2 focus-visible:ring-brand-blue-500/30 focus-visible:ring-offset-2',
      className
    )}
    {...props}
  >
    <span className="flex h-4 w-4 items-center justify-center rounded-full border-2 border-[var(--input-border-default)] bg-surface transition-colors duration-150 group-hover:border-[var(--input-border-hover)] group-data-[state=checked]:border-brand-blue-600">
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <span className="h-2 w-2 rounded-full bg-brand-blue-600" />
      </RadioGroupPrimitive.Indicator>
    </span>
    <span className="select-none">{children}</span>
  </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
